import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import SolarInverterSlider from "./shop-components/solar-inverter-slider";
import SolarInverterDetails from "./shop-components/solor-inverter-details";
import invertersData from "../data/invertersData";
// import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import CategoryInverters from "./section-components/category-inverters";

const Solar_Inverter = () => {
  const { id } = useParams(); // ✅ Get the ID from the URL
  const inverter = invertersData.find((item) => item.id === id); // ✅ Find the matching inverter
  console.log(inverter, "inverter---");

  if (!inverter) {
    return (
      <div className="container text-center mt-5">
        <h2>Product Not Found</h2>
        <p>The requested inverter does not exist.</p>
      </div>
    );
  }
  return (
    <div>
      <Navbar />
      <PageHeader
        headertitle={inverter.name}
        customclass="mb-0"
        Img="inverter.webp"
      />
      <SolarInverterSlider />
      <SolarInverterDetails inverter={inverter} />
      <CategoryInverters features={inverter?.features} />

      {/* <CallToActionV1 /> */}
      <Footer />
    </div>
  );
};

export default Solar_Inverter;
